import axios from "axios";
import { saveAs } from "file-saver";
import router from "@/router";

const BaseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.withCredentials = true;

export const HttpUtil = {
  post: function (url, params, callback = null, errorCallback = null) {
    var json = JSON.stringify(params);
    axios.interceptors.request.use(
      (config) => {
        return config;
      },
      (err) => {
        return Promise.reject(err);
      },
    );
    axios.interceptors.response.use(
      (response) => Promise.resolve(response),
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
        return Promise.reject(error);
      },
    );
    
    var authorization = sessionStorage.getItem("SesAuthenticationToken");
    var options = {
      headers: {
        "Authorization": authorization,
        "Content-Type": "application/json",
      },
      timeout: 30000 // タイムアウトを5000ミリ秒（5秒）に設定
    };

    axios
      .post(BaseURL + url, json, options)
      .then((response) => {
        if (callback) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (errorCallback) {
          errorCallback(error);
        } else if(!error.response){
          router.push("/error");
        }  else {
          callback(error.response.data);
        }
      })
      .finally(() => {
        // ネットワークエラーフラグのリセット
        sessionStorage.removeItem('networkError');
      });
      
  },

  export: function (
    url,
    params,
    initFileName,
    callback = null,
    errorCallback = null,

  ) {
    // var json = JSON.stringify(params);
    axios.interceptors.request.use(
      (config) => {
        return config;
      },
      (err) => {
        return Promise.reject(err);
      },
    );

    axios.interceptors.response.use(
      (response) => Promise.resolve(response),
      (error) => {
        if (error.response && (error.response.status === 400 || error.response.status === 401 )) {
          return Promise.resolve(error.response);
        } else {
          if (errorCallback) {
            errorCallback(error);
          }
          return Promise.reject(error.response);
        }
      },
    );

    var authorization = sessionStorage.getItem("SesAuthenticationToken");

    var options = {};
    options.headers = {
      "Authorization": authorization,
      "Content-Type": "application/json",
    };

    axios
      .post(BaseURL + url, params, options)
      .then((res) => {
        var data = res.data;
        // Base64からバイナリの文字列にデコード
        var binaryString = window.atob(data.file);
        
        // UTF-8のBOMを追加
        const binaryArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          binaryArray[i] = binaryString.charCodeAt(i);
        }
        // BOM付きのBlobを作成
        const blob = new Blob([binaryArray], {
          type: 'text/csv;charset=utf-8'
        });

        //レスポンスヘッダからファイル名を取得します
        // ファイル名の初期値を日付でフォーマットする処理に変更
        const now = new Date();
        const formattedDate =
          now.getFullYear().toString() +
          (now.getMonth() + 1).toString().padStart(2, "0") + // 月は0から始まるため+1する
          now.getDate().toString().padStart(2, "0") +
          now.getHours().toString().padStart(2, "0") +
          now.getMinutes().toString().padStart(2, "0") +
          now.getSeconds().toString().padStart(2, "0");

        let fileExtension = ".csv";
        
        if (url === "/outputGeoJson") {
          fileExtension = ".json";
        }

        let fileName = `${initFileName}${formattedDate}` + fileExtension;

        //ダウンロードします
        if (data.code === "200" && data.result === 0) {
          if(data.file != null ){
            saveAs(blob, fileName);
          }
          callback(data);
        } else {
          if (errorCallback) {
            errorCallback(data);
          }else {
            callback(data);
          }
        }
      })
      .catch(function () {
        router.push("/error");
      });
  },

  put: function (
    url,
    params,
    callback = null,
    errorCallback = null,
  ) {
    axios.interceptors.request.use(
      (config) => {
        return config;
      },
      (err) => {
        return Promise.reject(err);
      }
    );
    axios.interceptors.response.use(
      (response) => Promise.resolve(response),
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
        return Promise.reject(error);
      }
    );

    
    var authorization = sessionStorage.getItem("SesAuthenticationToken");
    var options = {};
    options.headers = {
      "Authorization": authorization,
      "Content-Type": "application/json",
    };
    axios
      .put(BaseURL + url, params, options)
      .then(function (response) {
        if (callback) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (errorCallback) {
          errorCallback(error);
        } else if(error.response === undefined){
          router.push("/error");
        } else {
          callback(error.response.data);
        }
      });
  }
};
